import React from 'react';
import SplitButton from './SplitButton';
import AddDocumentToCase from "./addDocumnetToCase";
import caseFileDeclined from "../../../enums/CaseFileDeclined";
import {Tooltip} from "@mui/material";

const RemoveObjectDoc = ({
                             documentTypes,
                             refreshCaseFiles,
                             documentTypesForEditor,
                             caseInfo,
                             barcode,
                             userId,
                             users,
                             permitTypeId,
                             objectOwner,
                             caseData,
                             ownerIdentificationTemplateString,
                             exploitationIdentificationTemplateString,
                             permitTypeTitle,
                             caseFiles,
                             userAddress


                         }) => {

    const removalDocExists = caseFiles.find(doc => doc.decline === caseFileDeclined.declineRemoveFromRegistery || doc.decline === caseFileDeclined.acceptRemoveFromRegistery);

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case 19:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        docType={doc}
                        objectOwner={objectOwner}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        caseInfo={caseInfo}
                        users={users}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}
                    />
                );
            case 18:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        caseInfo={caseInfo}
                        users={users}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}
                    />
                );
            default:
                return null;
        }
    };
    return (
        <div>
            <Tooltip title={removalDocExists && "დოკუმენტი უკვე შექმნილია!"}>
                <span>
                    <SplitButton
                        options={documentTypes}
                        renderDocumentComponent={renderDocumentComponent}
                        buttonLabel="ობიექტის ამოღებაზე პასუხი"
                        isDisabled={removalDocExists}
                    />
                </span>
            </Tooltip>
        </div>
    );
};

export default RemoveObjectDoc;
